import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountsContextService } from '../accounts/account-context.service';
import { OrganizationAclService } from './organization-acl.service';
import { map } from 'rxjs/operators';

export const forManagerInOrganization: CanActivateFn = route => {
  const router = inject(Router);
  const ctxService = inject(AccountsContextService);
  const organizationAclService = inject(OrganizationAclService);

  const routeOrganizationId: string | undefined = route.params['organizationId'];

  return organizationAclService.canManageOrganization(String(routeOrganizationId))
    .pipe(
      map(canManageOrganization => canManageOrganization ? true : router.createUrlTree([ctxService.ACCOUNTS_LIST_URL])),
    );
};
